export const IaptFeelingNervousAnxiousOrOnEdge = "IaptFeelingNervousAnxiousOrOnEdge";
export const IaptNotBeingAbleToStopOrControlWorrying = "IaptNotBeingAbleToStopOrControlWorrying";
export const IaptWorryingTooMuchAboutDifferentThings = "IaptWorryingTooMuchAboutDifferentThings";
export const IaptTroubleRelaxing = "IaptTroubleRelaxing";
export const IaptBeingSoRestlessThatItIsHardToSitStill = "IaptBeingSoRestlessThatItIsHardToSitStill";
export const IaptBecomingEasilyAnnoyedOrIrritable = "IaptBecomingEasilyAnnoyedOrIrritable";
export const IaptFeelingAfraidAsIfSomethingAwfulMightHappen = "IaptFeelingAfraidAsIfSomethingAwfulMightHappen";
